module.exports = __webpack_public_path__ + "assets/media/quota.234355d0.mp3";